import React from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import BackToTopButton from "./BackToTopButton";

function Layout(props) {
  return (
    <div className="layout-wrapper">
      <Header />
      <main>{props.children}</main>
      <Footer />
      <BackToTopButton />
    </div>
  );
}

export default Layout;
